export default {
  // App.css.js is used for App wide css rules
  // Component and View spesific css rules are with Views and Components eg. MainPage.css.js

  contentGrid: {
    width: '92%',
    marginLeft: '4%',
    marginRight: '4%'
  },

  paper: {
    marginTop: 60,
    paddingTop: 20,
    paddingLeft: 40,
    paddingRight: 40,
    paddingBottom: 60
  },

  paperFull: {
    marginTop: -20,
    marginLeft: -40,
    marginRight: -40
  },

  marginTop: { marginTop: 20},
  marginBottom: { marginBottom: 20},
  marginLeft: { marginLeft: 10 },
  marginRight: { marginRight: 10 },

  floatRight: { float: "right" },

  divider: {
    marginBottom: 20
  },

  smText: {
    fontSize: '80%'
  }
};



// WEBPACK FOOTER //
// ./src/views/App.css.js